/* NR 2026-09-28: product card hover mini buy box (snippets/nr-card-sizes). Size buttons update the price / per-100g
   line and value badge; 'Add to basket' posts to /cart/add.js and fires the theme's CartAddEvent so the cart
   count and drawer update exactly as they do from the product page. Loaded as a module, so it runs once per page. */
import { CartAddEvent, CartGroupedSections, ThemeEvents } from '@theme/events';

const L = (panel, k, d) => (panel && panel.dataset[k]) || d;

function select(panel, btn) {
  if (!panel || !btn) return;
  panel.querySelectorAll('[data-nr-qb-size]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
  panel.querySelector('[data-nr-qb-sel]').textContent = btn.dataset.sel || '';
  panel.querySelector('[data-nr-qb-unit]').textContent = btn.dataset.unit || '';
  const badge = panel.querySelector('[data-nr-qb-badge]');
  badge.textContent = btn.dataset.badge || '';
  badge.hidden = !btn.dataset.badge;
  const add = panel.querySelector('[data-nr-qb-add]');
  const ok = btn.dataset.available === 'true';
  add.disabled = !ok;
  add.textContent = ok ? L(panel, 'lAdd', 'Add to basket') : L(panel, 'lSold', 'Sold out');
  panel.dataset.variantId = btn.dataset.id;
  // 'View' opens the product page on the size they picked
  const view = panel.querySelector('[data-nr-qb-view]');
  if (view && btn.dataset.id) view.href = view.dataset.base + '?variant=' + btn.dataset.id;
}

// the box starts at the card's price line (covers price, ticks and button; never the photo or title)
function place(panel) {
  const price = panel.parentElement && panel.parentElement.querySelector('.nr-card-price');
  if (price && price.offsetParent === panel.parentElement) panel.style.setProperty('--nr-qb-top', price.offsetTop + 'px');
}

function init(root) {
  root.querySelectorAll('[data-nr-qb]:not([data-nr-qb-ready])').forEach((panel) => {
    panel.dataset.nrQbReady = '1';
    place(panel);
    select(panel, panel.querySelector('[data-nr-qb-size][aria-pressed="true"]') || panel.querySelector('[data-nr-qb-size]'));
  });
}

function sectionIds() {
  const ids = [];
  document.dispatchEvent(new CartGroupedSections(ids));
  return [...new Set(ids)];
}

async function addToBasket(panel, btn) {
  const id = panel.dataset.variantId;
  if (!id || btn.disabled) return;
  const msg = panel.querySelector('[data-nr-qb-msg]');
  btn.disabled = true;
  btn.classList.add('is-loading');
  msg.textContent = '';
  const body = new FormData();
  body.append('id', id);
  body.append('quantity', '1');
  const ids = sectionIds();
  if (ids.length) body.append('sections', ids.join(','));
  try {
    const url = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add.js';
    const res = await fetch(url, { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || L(panel, 'lError', 'Could not add to basket'));
    document.dispatchEvent(new CartAddEvent(data, String(id), { source: 'nr-card-qb', itemCount: 1, productId: panel.dataset.productId, sections: data.sections }));
    document.dispatchEvent(new CustomEvent(ThemeEvents.productAjaxAdded, { detail: { product: data } }));
    btn.textContent = L(panel, 'lAdded', 'Added ✓');
    msg.textContent = L(panel, 'lAddedMsg', 'Added to basket');
    setTimeout(() => { btn.textContent = L(panel, 'lAdd', 'Add to basket'); btn.disabled = false; msg.textContent = ''; }, 2000);
  } catch (e) {
    msg.textContent = e.message;
    btn.disabled = false;
    setTimeout(() => { msg.textContent = ''; }, 5000);
  } finally {
    btn.classList.remove('is-loading');
  }
}

document.addEventListener('click', (e) => {
  const panel = e.target.closest('[data-nr-qb]');
  if (!panel) return;
  if (e.target.closest('[data-nr-qb-view]')) return; // real link to the product page
  // other clicks inside the panel never open the product page (the card link sits underneath)
  e.preventDefault();
  e.stopPropagation();
  const size = e.target.closest('[data-nr-qb-size]');
  if (size) return select(panel, size);
  const add = e.target.closest('[data-nr-qb-add]');
  if (add) addToBasket(panel, add);
}, true);

init(document);
let rz;
window.addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => document.querySelectorAll('[data-nr-qb]').forEach(place), 150); });
document.addEventListener('pointerover', (e) => { const c = e.target.closest && e.target.closest('product-card'); const p = c && c.querySelector('[data-nr-qb]'); if (p) place(p); }, { passive: true });
// cards added later (filters, infinite scroll, section morphs)
new MutationObserver(() => init(document)).observe(document.body, { childList: true, subtree: true });
